// © Microsoft Corporation. All rights reserved.

import { NavBar, NavigationItem } from "./NavBar";
import { navBarTemplate as template } from "./NavBar.template";
import { navBarStyles as styles } from "./NavBar.styles";
import { customElement } from "@microsoft/fast-element";

@customElement({
    name: "msn-nav-bar",
    template,
    styles
})
export class MsnNavBar extends NavBar { }

export { NavigationItem };
export * from "./nav-item";
